<template>
    <h1>Fabric overview</h1>
</template>